import { render, staticRenderFns } from "./SPRAutoCompleteDropdown2.vue?vue&type=template&id=738b89be&scoped=true"
import script from "./SPRAutoCompleteDropdown2.vue?vue&type=script&lang=ts"
export * from "./SPRAutoCompleteDropdown2.vue?vue&type=script&lang=ts"
import style0 from "./SPRAutoCompleteDropdown2.vue?vue&type=style&index=0&id=738b89be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b89be",
  null
  
)

export default component.exports